<template>
	<b-modal id="login-modal"
					 :ok-disabled="true"
           :hide-footer="true"
	>
		<h3 slot='modal-header' class="text-center mb-3">Registered User?</h3>
		<div class="row">
			<div class="col-md" id="loginForm">
				<b-form>
					<div class="form-group row">
						<label for="loginInputEmail" class="col-sm-2 col-form-label">Email</label>
						<div class="col-sm-10">
							<b-form-input type="email"
														v-model="loginEmail"
														id="loginInputEmail"
														placeholder="Enter Email"
														:state="lastLoginFailed ? false : null"
							></b-form-input>
						</div>
					</div>
					<div class="form-group row">
						<label for="loginInputPassword" class="col-sm-2 col-form-label">Password</label>

						<div class="col-sm-10">
							<b-form-input type="password"
														v-model="loginPassword"
														id="loginInputPassword"
														placeholder="Enter Password"
														:state="lastLoginFailed ? false : null"
							></b-form-input>
							<b-form-invalid-feedback id="loginCredentialsBad">Incorrect credentials, please check username and password.</b-form-invalid-feedback>
							<!--<input type="password" id="loginInputPassword" class="form-control" placeholder="Password">-->
						</div>
					</div>
					<div class="form-group row" id="forgotPasswordContainer">
						<div class="col-sm-12">
							<a href="#" class="col-form-label" data-element="forgot"><label>Forgot Password?</label></a>
						</div>
					</div>
				</b-form>

				<div class="form-group row">
					<div class="col-sm-12">
						<button class="btn btn-success" @click="submitLogin()">Sign in</button>
					</div>
				</div>

			</div>
		</div>
	</b-modal>
</template>

<script>
	import {mapActions} from 'vuex';

	export default {
		name: "LoginModal",
		data: function() {
			return {
				loginEmail: "",
				loginPassword: "",
				lastLoginFailed: false,
				failureMessage: "",
			}
		},
		methods: {
			...mapActions('account',[
				'login'
			]),
			submitLogin(){
				this.login({
					email: this.loginEmail,
					password: this.loginPassword
				}).then(result => {
					if (result.status === 'failed'){
						this.lastLoginFailed = true;
						this.failureMessage = result.reason;
					} else {
            this.$root.$emit('bv::hide::modal', 'login-modal');
						this.$router.push("/projects");
					}
				});
			}
		}
	}
</script>

<style scoped>
	#forgotPasswordContainer {
		padding-top: 7px;
	}
</style>